import SalesReportListNew from './list';

const SalesListNew = () => {
	return <SalesReportListNew />;
};

export default SalesListNew;
